import { match } from 'ts-pattern'

export enum VehicleEligibilityRequirement {
  ACTIVE = 'ACTIVE',
  VEHICLE_MAKE = 'VEHICLE_MAKE',
  VEHICLE_MAKE_MODEL = 'VEHICLE_MAKE_MODEL',
  BEV = 'BEV',
  CONTROLLABLE = 'CONTROLLABLE',
  AUTH_METHOD = 'AUTH_METHOD',
  METER = 'METER',
  GRID_SUPPORT = 'GRID_SUPPORT',
  ALLOWED = 'ALLOWED',
  NOT_ALLOWED = 'NOT_ALLOWED',
  HAS_READ_PERMISSIONS = 'HAS_READ_PERMISSIONS',
  ELIGIBLE_THERMOSTAT_FOR_VEHICLE_ENROLLMENT = 'ELIGIBLE_THERMOSTAT_FOR_VEHICLE_ENROLLMENT',
  TOTAL_DEVICE_COUNT = 'TOTAL_DEVICE_COUNT',
  BATTERY_ELECTRIC_VEHICLE = 'BATTERY_ELECTRIC_VEHICLE',
}

export function vehicleIneligibilityReasonContent(
  key: VehicleEligibilityRequirement,
) {
  return match(key)
    .returnType<string>()
    .with(
      VehicleEligibilityRequirement.CONTROLLABLE,
      () => 'Vehicle must be controllable to enroll for this program.',
    )
    .with(
      VehicleEligibilityRequirement.VEHICLE_MAKE,
      () => `We don't support this vehicle currently for this program.`,
    )
    .with(
      VehicleEligibilityRequirement.VEHICLE_MAKE_MODEL,
      () => `This vehicle model isn't eligible for this program.`,
    )
    .with(
      VehicleEligibilityRequirement.ACTIVE,
      () => 'Vehicle must be active to enroll in this program.',
    )
    .with(
      VehicleEligibilityRequirement.BEV,
      () => 'Only battery electric vehicles are eligible for this program.',
    )
    .with(
      VehicleEligibilityRequirement.AUTH_METHOD,
      () => 'Vehicle authentication method is not supported.',
    )
    .with(
      VehicleEligibilityRequirement.METER,
      () => 'Vehicle meter configuration is not compatible.',
    )
    .with(
      VehicleEligibilityRequirement.GRID_SUPPORT,
      () => 'Vehicle does not support required grid functions.',
    )
    .with(
      VehicleEligibilityRequirement.ALLOWED,
      () => 'Vehicle is not on the allowed list for this program.',
    )
    .with(
      VehicleEligibilityRequirement.NOT_ALLOWED,
      () => 'Vehicle is specifically excluded from this program.',
    )
    .with(
      VehicleEligibilityRequirement.HAS_READ_PERMISSIONS,
      () => 'Vehicle does not have permissions to read charge data.',
    )
    .with(
      VehicleEligibilityRequirement.ELIGIBLE_THERMOSTAT_FOR_VEHICLE_ENROLLMENT,
      () => 'A thermostat is required before this vehicle can be enrolled.',
    )
    .with(
      VehicleEligibilityRequirement.TOTAL_DEVICE_COUNT,
      () =>
        'Vehicle cannot be enrolled due to maximum device count being reached for this enrollment.',
    )
    .with(
      VehicleEligibilityRequirement.BATTERY_ELECTRIC_VEHICLE,
      () => 'Only battery electric vehicles are eligible for this program.',
    )
    .otherwise(
      () =>
        `This vehicle requirement (${key.toString()}) is missing ineligibility content.`,
    )
}
